import React from 'react';
import { createPortal } from 'react-dom';

const REACTIONS = [
  { key: 'like', emoji: '👍', label: 'Like' },
  { key: 'love', emoji: '❤️', label: 'Love' },
  { key: 'haha', emoji: '😂', label: 'Haha' },
  { key: 'sad',  emoji: '😢', label: 'Sad'  },
  { key: 'care', emoji: '🥰', label: 'Care' },
];

const ReactionPicker = ({ open, x, y, onPick, onMouseEnter, onMouseLeave }) => {
  if (!open) return null;
  const node = (
    <div
      className="fixed z-50 bg-white border border-gray-200 rounded-2xl shadow-lg px-2 py-1 flex items-center gap-1"
      style={{ left: x, top: y, transform: 'translate(-50%, calc(-100% - 8px))' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {REACTIONS.map((r) => (
        <button
          key={r.key}
          type="button"
          className="px-2 py-1 rounded hover:bg-gray-100 text-xl leading-none"
          title={r.label}
          onClick={() => onPick(r.key)}
        >
          {r.emoji}
        </button>
      ))}
    </div>
  );
  return createPortal(node, document.body);
};

export { REACTIONS };
export default ReactionPicker;
